// Ensure base styles always load in the built dev portal
import '../src/styles.css';
// Mount the developer portal app
import '../src/dev-main';

// Best-effort: ensure Swagger UI + ReDoc assets are available on prod build too
// Vite sometimes drops external <link>/<script> from index.html during build.
// Inject them at runtime if missing so /docs pages render with styling.
try {
  const ensureLink = (href: string) => {
    if (!document.querySelector(`link[href="${href}"]`)) {
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l);
    }
  };
  const ensureScript = (src: string) => {
    if (!document.querySelector(`script[src="${src}"]`)) {
      const s = document.createElement('script');
      s.src = src; s.async = true; document.body.appendChild(s);
    }
  };
  ensureLink('https://unpkg.com/swagger-ui-dist@5/swagger-ui.css');
  ensureScript('https://unpkg.com/swagger-ui-dist@5/swagger-ui-bundle.js');
  ensureScript('https://unpkg.com/swagger-ui-dist@5/swagger-ui-standalone-preset.js');
  ensureScript('https://cdn.redoc.ly/redoc/latest/bundles/redoc.standalone.js');
} catch {}
